import { createContext, HTMLAttributes, ReactNode, useContext } from 'react';
import cx from 'classnames';
import styles from './Slides.module.scss';

interface ISlidesContext {
  onSlideChange?: (newActive: number) => void;
  slides: ReactNode[];
  active: number;
}

const SlidesContext = createContext<ISlidesContext>({
  onSlideChange: () => {},
  slides: [],
  active: -1,
});

interface SlidesProps extends ISlidesContext {
  children?: ReactNode;
}

export function Slides({ children, ...props }: SlidesProps) {
  return (
    <SlidesContext.Provider value={props}>{children}</SlidesContext.Provider>
  );
}

export function SlidesOutlet(props: HTMLAttributes<HTMLUListElement>) {
  const { slides, active } = useContext(SlidesContext);

  return (
    <ul {...props} className={cx(props.className, styles.slides)}>
      {slides.map((slide, key) => {
        const isActive = key === active;
        return (
          <li hidden={!isActive} key={key}>
            {slide}
          </li>
        );
      })}
    </ul>
  );
}

export function SlidesControl(props: HTMLAttributes<HTMLUListElement>) {
  const { onSlideChange, slides, active } = useContext(SlidesContext);
  return (
    <ul {...props} className={cx(props.className, styles.controls)}>
      {slides.map((_, key) => {
        const isActive = key === active;
        return (
          <li key={key}>
            <button
              className={cx(
                isActive && styles['control--active'],
                styles.control,
              )}
              name={`Navigate to slide ${key + 1}`}
              onClick={() => onSlideChange?.(key)}
              disabled={isActive}
            />
          </li>
        );
      })}
    </ul>
  );
}
